export default {
    name: 'breadcrumb',
    initialState: {
        items: [],
    },
    reducers: {
        setBreadcrumb: (state, { payload }) => {
            state.items = payload;
        },
    },
};
